import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { getCurrentUserID, getUserIsAuth } from '@/utils/GetStateInStore'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Account',
    meta: {
      layout: "AccountLayout",
      auth: true,
      title: 'Личный кабинет',
    },
    component: () => import('../views/Account.vue')
  },
  {
    path: '/Entrance',
    name: 'Entrance',
    meta: {
      layout: "AccountLayout",
      auth: true,
      title: 'Оформление членства',
    },
    component: () => import('../views/Entrance.vue')
  },
  {
    path: '/Registration',
    name: 'Registration',
    meta: {
      layout: "MainLayout",
      title: 'Регистрация'
    },
    component: () => import('../views/Registration.vue')
  },
  {
    path: '/ResetPassword',
    name: 'ResetPassword',
    meta: {
      layout: "MainLayout",
      title: 'Восстановление пароля'
    },
    component: () => import('../views/ResetPassword.vue')
  },
  {
    path: '/Login',
    name: 'Login',
    meta: {
      layout: "MainLayout",
      title: 'Вход в личный кабинет'
    },
    component: () => import('../views/Login.vue')
  },
  {
    path: '/ConfirmEmail',
    name: 'ConfirmEmail',
    meta: {
      layout: "MainLayout",
      title: 'Подтверждение email'
    },
    component: () => import('../views/ConfirmEmail.vue')
  },
  {
    path: '/PartnerPage',
    name: 'PartnerPage',
    meta: {
      layout: "AccountLayout",
      title: 'Страница партнёра'
    },
    component: () => import('../views/PartnerPage.vue')
  },

  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'hash', // Changed from 'history' to 'hash'
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const current_user = to.query?.current_user
  if (current_user) store.state.currentUserID = current_user

  if (to.meta?.auth && !getUserIsAuth()) {
    // Нужно проверять залогинен пользователь, если нет переадресовать на окно логина
    //console.log('route redirect Login')
    if (from.name !== "Login") next({ name: 'Login' })
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  const current_user = to.query?.current_user
    if (getCurrentUserID() && current_user != getCurrentUserID()) {
      next(to.path + '?current_user=' + getCurrentUserID());
    } else {
      next();
    }
}) //#

export default router
